import React from 'react';
import PropTypes from 'prop-types';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';

const DocumentFilter = ({
  t,
  color,
  filters,
  statusList,
  resetFilter,
  showFilters,
  changeFilter,
  handleSelect,
  applyFilters,
  toggleFilters,
  selectionRange,
}) => (
  <div>
    <div className={`${color} doc-filter`}>
      <div className="filter">
        <a
          href="#"
          className="filter-link"
          onClick={e => toggleFilters(e)}
        >{t('Filters ')}
          <img
            src="/img/droparrow.svg"
            height="6px"
            alt="droparrow"
            id="showMore"
            className={`img-more  ${showFilters ? 'rotate_act' : 'rotate_dis'}`}
          />
        </a>
      </div>
      { showFilters &&
        <React.Fragment>
          <div className={`status-box ${color} ext-box`}>
            <p className="tc thm-text">{`${t('Extension')}:`}</p>
            {Object.entries(statusList(t)).map(([k, v]) =>
          (<a
            key={k}
            href="#"
            className={filters[k] ? 'tc tc_act' : 'tc tc_dis st-dis'}
            onClick={e => changeFilter(e, k)}
          >{v}
          </a>))}
          </div>
          <p className="tc thm-text">{`${t('Date')}:`}</p>
          <DateRangePicker
            ranges={[selectionRange]}
            onChange={handleSelect}
            className={`emoj-list ${color}`}
            rangeColors={['var(--color-stop-1)']}
          />
          <a
            href="#"
            className="tc tc-next"
            onClick={e => applyFilters(e)}
          >{t('Apply')}
          </a>
          <a
            href="#"
            className="removesubtn nextme"
            onClick={e => resetFilter(e)}
          >{t('Reset')}
          </a>
        </React.Fragment>}
    </div>
  </div>
);

DocumentFilter.propTypes = {
  t: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  filters: PropTypes.object.isRequired,
  statusList: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  showFilters: PropTypes.bool.isRequired,
  changeFilter: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  toggleFilters: PropTypes.func.isRequired,
  selectionRange: PropTypes.object.isRequired,

};

export default DocumentFilter;



// WEBPACK FOOTER //
// ./src/components/modules/documentFilter/DocumentFilter.jsx